export const definedTranslation = {
  noOrders: {
    title: {
      id: 'ask-rep-modal-no-orders-title',
      defaultMessage: 'No Orders Yet',
    },
    subtitle: {
      id: 'ask-rep-modal-no-orders-subtitle',
      defaultMessage:
        'Discover textiles, wallcovering, paint, flooring, product finishes in our catalog',
    },
  },
  allCleared: {
    title: {
      id: 'ask-rep-modal-all-cleared-title',
      defaultMessage: 'All set!',
    },
    subtitle: {
      id: 'ask-rep-modal-all-cleared-subtitle',
      defaultMessage:
        'You’re clearly on top of things. We’ll update these options once you place a new order.',
    },
    button: {
      id: 'ask-rep-modal-all-cleared-button',
      defaultMessage: 'Start Sampling',
    },
  },
  contactMe: {
    id: 'ask-rep-modal-contact-me-text',
    defaultMessage:
      'I’d like to learn more about some of your materials. Can you contact me with more info?',
  },
  noYet: {
    id: 'ask-rep-modal-not-yet-label',
    defaultMessage: 'Not yet',
  },
  yes: {
    id: 'ask-rep-modal-yes-label',
    defaultMessage: 'Yes',
  },
  messageSent: {
    id: 'ask-rep-modal-message-sent-label',
    defaultMessage: 'Sent! Check ',
  },
  inboxLabel: {
    id: 'ask-rep-modal-message-inbox-label',
    defaultMessage: 'Inbox',
  },
  orderDate: {
    id: 'ask-rep-modal-order-date',
    defaultMessage: 'Order date',
  },
  repMethods: {
    messageSent: {
      id: 'ask-rep-modal-rep-method-message-sent-label',
      defaultMessage: 'Message sent!',
    },
    okForNow: {
      id: 'ask-rep-modal-rep-method-message-ok-for-now',
      defaultMessage: 'I’m Okay for Now',
    },
    readyToSpecify: {
      label: {
        id: 'ask-rep-modal-rep-method-ready-to-specify-label',
        defaultMessage: 'I’m Ready to Specify',
      },
      message: {
        id: 'ask-rep-modal-rep-method-ready-to-specify-message',
        defaultMessage:
          'I’d like to specify some of your materials. Can you contact me as soon as possible to kickstart the process?',
      },
      responseText: {
        id: 'ask-rep-modal-rep-method-ready-to-specify-response-text',
        defaultMessage: 'Will Connect With You Shortly',
      },
    },
    requestPricing: {
      label: {
        id: 'ask-rep-modal-rep-method-request-pricing-label',
        defaultMessage: 'Request Pricing',
      },
      message: {
        id: 'ask-rep-modal-rep-method-request-pricing-message',
        defaultMessage:
          'I’d like to obtain pricing info for some of your materials. Can you contact me with more details as soon as possible?',
      },
      responseText: {
        id: 'ask-rep-modal-rep-method-request-pricing-response-text',
        defaultMessage: 'Will Follow-Up With Pricing',
      },
    },
    requestAvailability: {
      label: {
        id: 'ask-rep-modal-rep-method-request-availability-label',
        defaultMessage: 'Request Availability',
      },
      message: {
        id: 'ask-rep-modal-rep-method-request-availability-message',
        defaultMessage:
          'Are these materials in stock? I’d like to learn more about them.',
      },
      responseText: {
        id: 'ask-rep-modal-rep-method-request-availability-response-text',
        defaultMessage: 'Will Follow-Up With Product Availability',
      },
    },
    requestLeadTime: {
      label: {
        id: 'ask-rep-modal-rep-method-request-lead-time-label',
        defaultMessage: 'Request Lead Time',
      },
      message: {
        id: 'ask-rep-modal-rep-method-request-lead-time-message',
        defaultMessage:
          'Can you provide lead times for these materials at your earliest convenience?',
      },
      responseText: {
        id: 'ask-rep-modal-rep-method-request-lead-time-response-text',
        defaultMessage: 'Will Follow-Up With Lead Time',
      },
    },
  },

  title: {
    id: 'ask-rep-modal-title',
    defaultMessage: 'Ready to connect?',
  },
  subtitle: {
    id: 'ask-rep-modal-subtitle',
    defaultMessage: 'Select an option below and a Brand Rep will be in touch',
  },
  getStartedTitle: {
    id: 'ask-rep-modal-contact-rep-title',
    defaultMessage: 'Let’s get started',
  },
  allProjectsLabel: {
    id: 'ask-rep-modal-all-projects-label',
    defaultMessage: 'All Projects',
  },
  seeMoreProjectsButton: {
    id: 'ask-rep-modal-see-more-projects-button',
    defaultMessage: 'See More Projects',
  },
  sort: {
    new: {
      id: 'ask-rep-modal-sort-newest',
      defaultMessage: 'Newest first',
    },
    old: {
      id: 'ask-rep-modal-sort-oldest',
      defaultMessage: 'Oldest first',
    },
  },
  items: {
    hideDetailsButton: {
      id: 'ask-rep-modal-item-hide-details-button',
      defaultMessage: 'Hide Details',
    },
    repLabel: {
      id: 'ask-rep-modal-item-rep-label',
      defaultMessage: 'Rep',
    },
    projectLabel: {
      id: 'ask-rep-modal-item-project-label',
      defaultMessage: 'Project',
    },
  },
  actions: {
    scheduleMeeting: {
      id: 'ask-rep-modal-item-actions-schedule-meeting',
      defaultMessage: 'Schedule a Meeting',
    },
    requestInformation: {
      id: 'ask-rep-modal-item-actions-request-info',
      defaultMessage: 'Request Information',
    },
    sendMessage: {
      id: 'ask-rep-modal-item-actions-send-message',
      defaultMessage: 'Send a Message',
    },
    okey: {
      id: 'ask-rep-modal-item-actions-ok-for-now',
      defaultMessage: "I'm Okey for Now",
    },
  },
  contactMethodMessages: {
    scheduleMeeting: {
      id: 'ask-rep-modal-item-contact-method-schedule-meeting-messages',
      defaultMessage: 'Will Follow Up With Available Times',
    },
    requestInformation: {
      id: 'ask-rep-modal-item-contact-method-request-info-messages',
      defaultMessage: 'Will Share Documents With You Shortly',
    },
    sendMessage: {
      id: 'ask-rep-modal-item-contact-method-send-message-messages',
      defaultMessage: 'Your message has been sent to',
    },
    okey: {
      id: 'ask-rep-modal-item-contact-method-messages',
      defaultMessage: 'I’m Okay for Now',
    },
  },
  contactRepModal: {
    placeholders: {
      products: {
        id: 'ask-rep-modal-contact-rep-products-placeholder',
        defaultMessage:
          'Please select the items you’d like more information about',
      },
      product: {
        id: 'ask-rep-modal-contact-rep-product-placeholder',
        defaultMessage: 'You will be contacted by the rep for this product',
      },
      documentType: {
        id: 'ask-rep-modal-contact-rep-document-type-placeholder',
        defaultMessage: 'Please select a document type',
      },
    },
  },
};
